export type BudgetMetrics = {
    /** Share of the budget spent so far. */
    usedPct: number;
    /** Share of the year elapsed (months with data of 12). */
    elapsedPct: number;
    /** Spend projected for the full year at this year's pace. */
    runRate: number;
    /** Projected full-year spend against the budget: +10 means 10% over budget. */
    runRateVsBudgetPct: number;
};

/** Budget vs actual (spec 4.4) from the annual budget, spend so far this year and the months elapsed. */
export function budgetMetrics(budget: number, actualYtd: number, monthsElapsed: number): BudgetMetrics | null {
    if (budget <= 0 || monthsElapsed <= 0) return null;
    const runRate = actualYtd / monthsElapsed * 12;
    return {
        usedPct: Math.round(1000 * actualYtd / budget) / 10,
        elapsedPct: Math.round(1000 * monthsElapsed / 12) / 10,
        runRate,
        runRateVsBudgetPct: Math.round(1000 * (runRate - budget) / budget) / 10,
    };
}
